import { Injectable } from "@angular/core";
import { AngularFireFunctions } from "@angular/fire/compat/functions";
import { NotificationType } from "../models/notification-type.model";
import { UserTypeEnum } from "../models/user-type";

@Injectable({
    providedIn: 'root',
})
export class EmailNotificationService {

    constructor(
        private angularFunctions: AngularFireFunctions
    ) { }

    async sendDoctorInvitationEmail(
        email: string,
        name: string
    ) {
        try {
            const callable = this.angularFunctions.httpsCallable('invitedDoctor');

            callable({
                email: email,
                name: name
            })
                .toPromise()
                .then((result) => console.log('invitedDoctor', result))
                .catch((error) => console.log('invitedDoctor', error));

        } catch (error) {
            console.log('invitedDoctor(): ' + JSON.stringify(error));
        }
    }

    async sendExpertInvitationEmail(
        email: string,
        name: string
    ) {
        try {
            const callable = this.angularFunctions.httpsCallable('invitedExpert');

            callable({
                email: email,
                name: name
            })
                .toPromise()
                .then((result) => console.log('invitedExpert', result))
                .catch((error) => console.log('invitedExpert', error));

        } catch (error) {
            console.log('invitedExpert(): ' + JSON.stringify(error));
        }
    }

    async sendPushNotificationOnly(
        user_type: UserTypeEnum,
        user_id: string,
        subject: string,
        message: string,
        appointment_type: NotificationType,
        appointment_id: string
    ) {
        try {
            const callable = this.angularFunctions.httpsCallable('sendPushNotification');

            callable({
                user_type,
                user_id,
                subject,
                message,
                appointment_type,
                appointment_id
            })
                .toPromise()
                .then((result) => console.log('sendPushNotification', result))
                .catch((error) => console.log('sendPushNotification', error));

        } catch (error) {
            console.log('sendPushNotification(): ' + JSON.stringify(error));
        }
    }

    async sendEmailAndPush(
        user_type: UserTypeEnum,
        user_id: string,
        subject: string,
        message: string,
        appointment_type: NotificationType,
        appointment_id: string
    ) {
        try {
            const callable = this.angularFunctions.httpsCallable('sendEmailAndPush');

            callable({
                user_type,
                user_id,
                subject,
                message,
                appointment_type,
                appointment_id
            })
                .toPromise()
                .then((result) => console.log('sendEmailAndPush', result))
                .catch((error) => console.log('sendEmailAndPush', error));

        } catch (error) {
            console.log('sendEmailAndPush(): ' + JSON.stringify(error));
        }
    }

    async sendEmail(
        subject: string,
        email: string,
        message: string,
        name: string
    ) {
        try {
            const callable = this.angularFunctions.httpsCallable('genericEmail');

            callable({
                email: email,
                subject: subject,
                message: message,
                name: name
            })
                .toPromise()
                .then((result) => console.log('sendEmail', result))
                .catch((error) => console.log('sendEmail', error));

        } catch (error) {
            console.log('sendEmail(): ' + JSON.stringify(error));
        }
    }

    async sendMultipleEmails(
        subject: string,
        emails: string[],
        message: string,
        name: string
    ) {
        try {
            const callable = this.angularFunctions.httpsCallable('multipleGenericEmails');

            callable({
                emails: emails,
                subject: subject,
                message: message,
                name: name
            })
                .toPromise()
                .then((result) => console.log('sendEmail', result))
                .catch((error) => console.log('sendEmail', error));

        } catch (error) {
            console.log('sendEmail(): ' + JSON.stringify(error));
        }
    }

    async sendCIMANotification(contact: any, phone: string, message: string) {
        try {
          const callable = this.angularFunctions.httpsCallable('sendCIMAWebhook');
    
          callable({
            first_name: contact.first_name,
            last_name: contact.last_name,
            email: contact.email,
            phone: phone,
            message: message
          })
            .toPromise()
            .then((result) => console.log('sendCIMANotification', result))
            .catch((error) => console.log('sendCIMANotification', error));
        } catch (error) {
          console.log('sendCIMANotification(): ' + JSON.stringify(error));
        }
      }

    async sendCIMALocationNotification(contact: any, phone: string, message: string) {
        try {
          const callable = this.angularFunctions.httpsCallable('sendCIMAWebhook');
    
          callable({
            first_name: contact.contact_name ?? '',
            last_name: '',
            email: contact.email,
            phone: phone,
            message: message
          })
            .toPromise()
            .then((result) => console.log('sendCIMANotification', result))
            .catch((error) => console.log('sendCIMANotification', error));
        } catch (error) {
          console.log('sendCIMANotification(): ' + JSON.stringify(error));
        }
      }
}